<div class="modal-content">
    <h5 i18n class="title">Select Your Card</h5>
    <span class="absolute pointer modal-close-svg pad-10" *ngIf = "selectedCardId">
      <svg  (click)="_bsModalRef.hide()" width="15" height="15"
          viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
              d="M15 1.51071L13.4893 0L7.5 5.98929L1.51071 0L0 1.51071L5.98929 7.5L0 13.4893L1.51071 15L7.5 9.01071L13.4893 15L15 13.4893L9.01071 7.5L15 1.51071Z"
              fill="#919aa2" />
      </svg>
    </span>
    <section class="cards">
      <ng-container *ngIf="userCards">
          <div *ngFor="let each of userCards">
              <div class="flex justify-content-between mar-top-5 mar-bot-5">
                  <span class="fnt-14 align-self-center capitalize" [innerHtml] = "each.attributes.display_name.toLowerCase()"></span>
                  <div class="flex align-center justify-content-center" style="min-width: 8em;">
                      <button i18n class="add-cart-btn pointer" (click)="setCard(each)"
                          *ngIf="each.id!=selectedCardId">Select</button>
                      <span i18n class="remove" *ngIf="each.id==selectedCardId">Selected</span>
                  </div>
              </div>
              <hr>
          </div>
      </ng-container>
      <div *ngIf="!userCards || userCards.length === 0" class="flex align-center justify-center h100 loader-coupon pad-top-20 pad-bot-50">
          <div class="page-loader"></div>
      </div>
    </section>
</div>
